import React, {ReactNode} from 'react';
import InputCustom from "@ui/inputs/InputCustom";
import LabelWrapperSingleVoyage from "@containers/singleVoyage/ui/labelWrapper/LabelWrapperSingleVoyage";
import {sx} from './sx'

interface IProps {
    value: string,
    onChange: (value: string) => void,
    label?: string,
    multiline?: boolean,
    rows?: number,
    endIcon?: ReactNode,
    fullWidth?: boolean,
    error?: boolean,
    errorMessage?: string,
    variant?: 'secondary' | 'primary',
    placeholder?:string,
    disabled?:boolean
}

const InputSingleVoyage = ({
                               value,
                               onChange,
                               label,
                               multiline,
                               rows,
                               endIcon,
                               fullWidth = true,
                               error,
                               errorMessage,
                               variant = 'primary',
                               placeholder,
                               disabled
                           }: IProps) => {
    return (
        <LabelWrapperSingleVoyage
            fullWidth={fullWidth}
            label={label}
            variant={variant}
        >
            <InputCustom
                sx={sx.root}
                value={value}
                onChange={onChange}
                multiline={multiline}
                rows={rows}
                InputProps={{
                    endAdornment: endIcon
                }}
                fullWidth={fullWidth}
                error={error}
                errorMessage={errorMessage}
                placeholder={placeholder}
                disabled={disabled}
            />
        </LabelWrapperSingleVoyage>
    );
};

export default InputSingleVoyage;